import { Suspense, type ReactNode } from "react";
import { Await } from "react-router";

export { hydrateApplication, renderApplication } from "./runtime";
export type { RenderRequest } from "./runtime";

export interface DeferredBoundaryProps<T> {
  readonly value: Promise<T>;
  readonly fallback: ReactNode;
  readonly children: (value: T) => ReactNode;
  readonly error?: ReactNode;
}

export function DeferredBoundary<T>({
  value,
  fallback,
  children,
  error,
}: DeferredBoundaryProps<T>) {
  return (
    <Suspense fallback={fallback}>
      <Await resolve={value} errorElement={error}>
        {children}
      </Await>
    </Suspense>
  );
}

export function escapeHydrationJson(value: unknown): string {
  return JSON.stringify(value)
    .replaceAll("<", "\\u003c")
    .replaceAll(">", "\\u003e")
    .replaceAll("&", "\\u0026")
    .replaceAll("\u2028", "\\u2028")
    .replaceAll("\u2029", "\\u2029");
}
